import { Component, OnInit } from '@angular/core';
import { SedsModalService } from "@serasa/shared/seds";
import { Observable } from 'rxjs';

import { ExportModalComponent } from '../export-modal/export-modal.component';
import {
  ExportButtonState,
  ExportButtonStateEnum,
} from '../../interfaces/export-status.interface';
import { ExportPollingService } from '../../services/export-polling.service';

@Component({
    selector: 'pl-export-button',
    templateUrl: './export-button.component.html',
    styleUrls: ['./export-button.component.scss'],
    standalone: false
})
export class ExportButtonComponent implements OnInit {
  public buttonState$: Observable<ExportButtonState>;
  public ExportButtonStateEnum = ExportButtonStateEnum;

  constructor(
    private readonly _modalService: SedsModalService,
    private readonly _exportPollingService: ExportPollingService,
  ) {
    this.buttonState$ = this._exportPollingService.buttonState$;
  }

  ngOnInit(): void {
    this._exportPollingService.checkInitialStatus();
  }

  public onButtonClick(state: ExportButtonState): void {
    
    switch (state.buttonState) {
      case ExportButtonStateEnum.REQUEST_EXPORT:
        this.openModalAndRequest();
        break;

      case ExportButtonStateEnum.DOWNLOAD_READY:
        this._exportPollingService.downloadFile().subscribe();
        break;

      case ExportButtonStateEnum.IN_PROCESSING:
      default:
        break;
    }
  }

  private openModalAndRequest(): void {
    
    this._modalService.open(ExportModalComponent, null, {
      width: '536px',
      maxWidth: '536px',
    });

    this._modalService.close().subscribe((result) => {
      
      if (result === 'confirmed') {
        this._exportPollingService.requestExport().subscribe();
      }
    });
  }

  public onDownload(): void {
    this._exportPollingService.downloadFile().subscribe();
  }
}

